import React, { useState, useRef } from "react";
import { ProductFilters } from "../../types/productFilters";

interface SearchFiltersProps {
  filters: ProductFilters;
  onFilterChange: (filters: ProductFilters) => void;
  loading: boolean;
}

const SearchFilters: React.FC<SearchFiltersProps> = ({
  filters,
  onFilterChange,
  loading,
}) => {
  const [searchValue, setSearchValue] = useState(filters.searchTerm || "");
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Solo ejecutar la búsqueda si tiene más de 4 caracteres o está vacío
    if (value.length === 0 || value.length >= 4) {
      timeoutRef.current = setTimeout(() => {
        onFilterChange({
          ...filters,
          page: 1,
          searchTerm: value,
        });
      }, 500); // 500ms de delay
    }
  };

  const handleHasImagesChange = (value: boolean | undefined) => {
    onFilterChange({ ...filters, hasImages: value });
  };

  // Cleanup del timeout al desmontar el componente
  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="row g-3 align-items-center">
      <div className="col-md-6">
        <div className="input-group">
          <span className="input-group-text">
            <i className="bi bi-search"></i>
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Buscar por código o nombre... (min 4 caracteres)"
            value={searchValue}
            onChange={handleSearchChange}
            disabled={loading}
          />
        </div>
        {searchValue.length > 0 && searchValue.length < 4 && (
          <small className="text-muted">
            Escribe al menos 4 caracteres para buscar
          </small>
        )}
      </div>

      <div className="col-md-6">
        <div className="btn-group" role="group">
          <button
            type="button"
            className={`btn ${filters.hasImages === undefined ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => handleHasImagesChange(undefined)}
            disabled={loading}
          >
            Todos
          </button>
          <button
            type="button"
            className={`btn ${filters.hasImages === true ? "btn-success" : "btn-outline-success"}`}
            onClick={() => handleHasImagesChange(true)}
            disabled={loading}
          >
            Con imágenes
          </button>
          <button
            type="button"
            className={`btn ${filters.hasImages === false ? "btn-warning" : "btn-outline-warning"}`}
            onClick={() => handleHasImagesChange(false)}
            disabled={loading}
          >
            Sin imágenes
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;
